import React, { FC, useEffect } from "react";

import { useSelector } from "react-redux";

import { getFetchStatus, getSearchAiSummaryText } from "../../../../store/searchAiSummary/selectors";
import GenAiSearchSummary from "../../GenAiSearchSummary";

import useAiSummaryController from "./useAiSummary.controller";
import flights_web_sr_gen_ai_summary_v3_mdot from "../../../../utils/experiments/funnel/flights_web_sr_gen_ai_summary_v3_mdot";

const AiSummaryMobile: FC<{ visible?: boolean; onClose?: VoidFunction }> = ({ visible, onClose }) => {
  useAiSummaryController("v2");
  const fetchStatus = useSelector(getFetchStatus);
  const summaryText = useSelector(getSearchAiSummaryText);

  useEffect(() => {
    if (visible) {
      fetchStatus === "loading" && flights_web_sr_gen_ai_summary_v3_mdot.goals.loading();
      fetchStatus === "success" && flights_web_sr_gen_ai_summary_v3_mdot.goals.success();
      fetchStatus === "failed" && flights_web_sr_gen_ai_summary_v3_mdot.goals.error();
    }
  }, [visible, fetchStatus]);

  return (
    <GenAiSearchSummary
      variant="modal_only"
      summaryText={summaryText || ""}
      summaryVisible={visible}
      modalPosition="bottom"
      isLoading={fetchStatus === "loading"}
      isError={fetchStatus === "failed"}
      onModalClose={onClose}
    />
  );
};

export default AiSummaryMobile;
